import { observer } from "mobx-react-lite"
import { storeAnnotation } from "mobx/dist/internal"
import { appConfig } from "../models/constants"
import { ProfileStore } from "../stores/ProfileStore"

export const BioText = observer((props: { store: ProfileStore }) => {

    return (
        <div className='flex-column' style={{ width: '80%' }} >
            <h3>About You</h3>
            <div className='bio-text-wrapper' style={{position:'relative'}}>
                <textarea className='bio-text' name=""
                    maxLength={appConfig.BIO_LENGTH}
                    value={props.store.bio}
                    onChange={(e) => props.store.updateBio(e.target.value)}  ></textarea>
                    <p style={{position:'absolute', right: 10, bottom: 10}} >{props.store.bio.length}/{appConfig.BIO_LENGTH}</p>
            </div>
            
        </div>
    )
})